<template>
  <div>
    <div class="acoes">
      <button class="btn btn-outline-primary" @click.prevent="novoContato"> Novo Contato </button>
    </div>

    <filtro-pesquisa-interessado class="p-2"
      :rowsNumber="5"
      :eventBusDataName="eventBusDataName"
      :eventBusPaginationName="eventBusPaginationName"/>

    <data-table-consulta-comp class="mt-3"
      :colNames="colNames"
      :eventBusDataName="eventBusDataName"
      :eventBusDataPaginationName="eventBusPaginationName"
      :dataTableColumn="dataTableColumn">
      <template v-slot="slotProps">
        <td style="text-align: center; width: 100px !important;">
            <i class="fa fa-pencil-square-o fa-1-5x" aria-hidden="true" v-on:click="editar(slotProps.itemData.id)"></i>
            <i class="fa fa-trash-o fa-1-5x" aria-hidden="true" @click.prevent="() => {
                guardarDadosInteressado(slotProps.itemData)
                $refs.confirmacaoExclusao.openModal()
              }"></i>
        </td>
      </template>
    </data-table-consulta-comp>
    <modal ref="confirmacaoExclusao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Realmente deseja Inativar o interessado {{ nomeInteressadoExcluir }} ?</h4>
          <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.confirmacaoExclusao.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <label v-if="nomeUsuarioCriacaoInteressado" class="text-primary m-3">Usuário responsavél pela criação do interessado: {{ nomeUsuarioCriacaoInteressado }}</label>
        <div class="modal-body text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-danger m-1" @click.prevent="$refs.confirmacaoExclusao.closeModal()">Cancelar</button>
          <button type="button" class="btn btn-outline-primary m-1" @click.prevent="excluir(idInteressadoExcluir)">Confirmar</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'
import filtroPesquisaInteressado from '@/components/filtro/FiltroPesquisaInteressado'

import InteressadoService from '@/services/InteressadoService'

import eventBus from '@/uteis/eventBus'
import modal from '@/components/shared/Modal.vue'

export default {
  components: {
    dataTableConsultaComp,
    filtroPesquisaInteressado,
    modal
  },

  data () {
    return {
      colNames: ['Tipo', 'Nome', 'CPF/CNPJ', 'Ações'],
      dataTableColumn: [
        'tipoContatoExterno',
        'nome',
        'identificador'
      ],
      eventBusDataName: 'consultaInteressadoElaboracaoData',
      eventBusPaginationName: 'consultaInteressadoElaboracaoDataPagination',
      idInteressadoExcluir: '',
      nomeInteressadoExcluir: '',
      nomeUsuarioCriacaoInteressado: ''
    }
  },

  created () {
    this.interessadoService = new InteressadoService()
  },

  methods: {
    editar (id) {
      this.$router.push({ name: 'manterInteressados', query: { idContatoExterno: id } })
    },

    excluir (id) {
      this.interessadoService.excluir(id).then(() => {
        eventBus.$emit(this.eventBusPaginationName, 1)
        this.$refs.confirmacaoExclusao.closeModal()
      }).catch(err => {
        console.log(err)
      })
    },

    novoContato () {
      this.$router.push({ name: 'manterInteressados' })
    },

    voltar () {
      this.$router.back()
    },

    guardarDadosInteressado (obj) {
      console.log('Objeto interessado: ', obj)
      this.idInteressadoExcluir = 0
      this.nomeInteressadoExcluir = ''
      this.nomeUsuarioCriacaoInteressado = ''

      this.idInteressadoExcluir = obj.id
      this.nomeInteressadoExcluir = obj.nome
      this.nomeUsuarioCriacaoInteressado = obj.usuarioCriacao
    }
  }
}
</script>

<style scoped lang="scss">
.acoes {

  .btn {
    margin-right: 10px;
    width: 150px;
    height: 28px;
  }
}
</style>
